var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicDanger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.75C7.5 2.92157 8.17157 2.25 9 2.25C9.82843 2.25 10.5 2.92157 10.5 3.75V6.75",
    stroke: "#E34A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30176 8.8875C5.60926 10.65 7.14676 12 8.99926 12C9.84206 12 10.6197 11.7206 11.2459 11.25L12.3743 12.2694C11.6423 12.8821 10.7403 13.2989 9.74926 13.44V15C9.74926 15.4125 9.41176 15.75 8.99926 15.75C8.58676 15.75 8.24926 15.4125 8.24926 15V13.44C5.98426 13.1175 4.18426 11.355 3.81676 9.105C3.74926 8.655 4.10926 8.25 4.56676 8.25C4.93426 8.25 5.24176 8.52 5.30176 8.8875Z",
    fill: "#E34A4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.46967 2.46967C2.76256 2.17678 3.23744 2.17678 3.53033 2.46967L15.5303 14.4697C15.8232 14.7626 15.8232 15.2374 15.5303 15.5303C15.2374 15.8232 14.7626 15.8232 14.4697 15.5303L2.46967 3.53033C2.17678 3.23744 2.17678 2.76256 2.46967 2.46967Z",
    fill: "#E34A4A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 8.25C6.75 9.49264 7.75736 10.5 9 10.5C9.46003 10.5 9.88781 10.3619 10.2442 10.125L6.75 6.75V8.25Z",
    fill: "#E34A4A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 15C8.25 15.4142 8.58579 15.75 9 15.75C9.41421 15.75 9.75 15.4142 9.75 15H8.25ZM8.25 12.75V15H9.75V12.75H8.25Z",
    fill: "#E34A4A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 8.25C5.25 7.83579 4.91421 7.5 4.5 7.5C4.08579 7.5 3.75 7.83579 3.75 8.25H5.25ZM9 12C6.92893 12 5.25 10.3211 5.25 8.25H3.75C3.75 11.1495 6.1005 13.5 9 13.5V12ZM11.3202 11.1963C10.6817 11.6999 9.87696 12 9 12V13.5C10.2259 13.5 11.3556 13.0789 12.2492 12.374L11.3202 11.1963Z",
    fill: "#E34A4A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5022 8.25C13.5022 8.50553 13.4809 8.75609 13.4399 9C13.3966 9.25811 13.3314 9.50878 13.2461 9.75",
    stroke: "#E34A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3L15 15",
    stroke: "#E34A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicDanger);
export default __webpack_public_path__ + "static/media/MicDanger.2cc0fa000fe422ba36dc9ef3642f2c9f.svg";
export { ForwardRef as ReactComponent };